var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-wrap align-items-center"},[_c('div',{staticClass:"mr-auto"},[_c('p',{staticClass:"text-uppercase text-dark font-weight-bold mb-1"},[_vm._v(" Orders ")]),_c('p',{staticClass:"text-gray-5 mb-0"},[_vm._v(" All Time Orders ")])]),_c('p',{staticClass:"text-primary font-weight-bold font-size-24 mb-0"},[_vm._v(" 1,800 ")])])
}]

export { render, staticRenderFns }